export namespace Global {
	export let iframeHtml: HTMLIFrameElement;
}
